<template>
  <HeaderComponent />

  <router-view />
</template>
